module.exports = __webpack_public_path__ + "img/liability-limits@2x.75fb11e5.jpg";